import { AugmentedCreateTeamInput } from '@/types/schema';

import { TeamFormShape } from './TeamModal.types';

export const mapFormDataToInput = (
  data: TeamFormShape
): AugmentedCreateTeamInput => ({
  create: {
    name: data.name,
    assignedHouseholdIDs: data.assignedHouseholdIds,
    employeeIDs: data.employeeIds,
  },
});
